module.exports = __webpack_public_path__ + "img/25.e497aa46.jpg";